var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageModulePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 186,
    viewBox: "0 0 328 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.25,
    width: 327,
    height: 183.5,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.99 71.963H145.927C142.692 71.963 140 74.6537 140 77.9736V108.026C140 111.346 142.691 114.037 145.926 114.037H181.989C185.309 114.037 188 111.346 188 108.026V77.9736C188.001 74.6537 185.39 71.963 181.99 71.963ZM183.493 107.397L170.645 89.9384C170.411 89.5063 169.875 89.2434 169.302 89.2434C168.728 89.2434 168.192 89.5033 167.874 89.9364L157.863 103.47L154.379 99.1401C154.056 98.7382 153.54 98.5006 152.992 98.5006C152.443 98.5006 151.928 98.7381 151.604 99.1401L144.512 107.95C144.512 107.953 144.512 107.947 144.512 107.95L144.508 77.9736C144.508 77.1451 145.182 76.4709 146.01 76.4709H182.074C182.902 76.4709 183.577 77.1451 183.577 77.9736V107.397H183.493Z",
    fill: "#B3C0C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.276 80.2275C151.786 80.2275 149.768 82.2458 149.768 84.7355C149.768 87.2252 151.786 89.2434 154.276 89.2434C156.766 89.2434 158.784 87.2252 158.784 84.7355C158.784 82.2458 156.765 80.2275 154.276 80.2275Z",
    fill: "#B3C0C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.25,
    width: 327,
    height: 183.5,
    rx: 3.5,
    stroke: "#B3C0C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageModulePlaceholder);
export default __webpack_public_path__ + "static/media/image-module-placeholder.fcd97d30ab5f3bfef9e93f5a831e9eaf.svg";
export { ForwardRef as ReactComponent };